module.exports = __webpack_public_path__ + "static/media/mv.dd23d996.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mv.svg
// module id = 200
// module chunks = 0